import type { CSSProperties, ReactNode } from 'react';

export type PhaseTagProps = {
  size?: number;
  /** Tracking in em (default 0.22). */
  tracking?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/**
 * Typewriter kicker used as a "PHASE 0X · LABEL" eyebrow above paper
 * headers. Renders Special Elite, uppercase, wide tracking. Distinct
 * from `.eyebrow` (display family) — this is the type-machine voice.
 */
export const PhaseTag = ({
  size = 12,
  tracking = 0.22,
  color = 'var(--color-ink-soft)',
  className,
  style,
  children,
}: PhaseTagProps) => {
  return (
    <div
      className={['type', className ?? ''].filter(Boolean).join(' ')}
      style={{
        fontSize: size,
        letterSpacing: `${tracking}em`,
        color,
        textTransform: 'uppercase',
        ...(style ?? {}),
      }}
    >
      {children}
    </div>
  );
};
